import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { PosFormCreate } from '@/features/pos/components/pos-form'

export const Route = createFileRoute('/_app/outlet/pos/create')({
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<PageLayout>
			<PageLayout.Header
				breadcrumbs={[
					['/outlet', 'Outlet'],
					['/outlet/pos', 'Point of Sale'],
					['/outlet/pos/create', 'Tambah Perangkat'],
				]}
			/>
			<PageCard.Root>
				<PageCard.Header title="Buat Perangkat POS" />
				<PosFormCreate />
			</PageCard.Root>
		</PageLayout>
	)
}
